import {
  LIST_COMMUNITY_ALERTS_RESPONSE,
  LIST_UNIT_ALERTS_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// alertId -> {alert}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_COMMUNITY_ALERTS_RESPONSE:
    case LIST_UNIT_ALERTS_RESPONSE: {
      const s = { ...state }
      const alerts = action.alerts || []
      alerts.forEach((a) => {
        s[a.id] = a
      })
      return s
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
